export const mermaidDirective = {
    name: 'mermaid',
    body: {
        type: String,
        required: true,
    },
    run(data) {
        return [
            {
                type: 'mermaid',
                value: data.body,
            },
        ];
    },
};
